import React from "react";
import Helmet from "react-helmet";
import Grid from "@material-ui/core/Grid";
import { Typography, withStyles } from "@material-ui/core";
import MenuBar from "./MenuBar";
import cover from "../data/img/cover.svg";

const styles = {
  banner: {
    height: 500,
    paddingLeft: "12%",
    paddingRight: "12%"
  },
  card: {
    maxWidth: 600
  }
};

function Header(props) {
  const { classes } = props;
  return (
    <Grid container>
      <Helmet title="RL">
        <meta name="description" content="in-browser reinforcement learning" />
        <meta property="og:title" content="gym.js" />
        <meta
          property="og:description"
          content="in-browser reinforcement learning"
        />
        {props.scripts}
      </Helmet>
      <MenuBar />
      {props.showHeader && (
        <Grid
          container
          item
          alignContent="space-around"
          alignItems="center"
          className={classes.banner}
          spacing={16}
        >
          <Grid item md={6} sm={6} xs={12}>
            <Typography variant="h1" align="left" gutterBottom>
              Interactive Reinforcement Learning
            </Typography>
            <Typography variant="subtitle1" align="left">
              An in-browser environment and community for learning about and
              developing reinforcement learning agents rapidly.
            </Typography>
          </Grid>
          <Grid item md={6} sm={6} xs={12} className={classes.card}>
            <img src={cover} alt="Interactive reinforcement learning." />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}

export default withStyles(styles)(Header);
